module.exports = __webpack_public_path__ + "_assets/img/history.f7328382.svg";